// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { ButtonGroup, NavLink } from 'react-bootstrap'
import './TitlePage.scss'

const TitlePage: React.FC = (): JSX.Element => {
  const siteURL: any = process.env.CONSOLE_URL
  const contactSupport: any = process.env.CONTACT_SALES_URL

  return (
    <div className="title-overlay">
      <video
        autoPlay
        loop
        muted={true}
        id="background-video"
        playsInline
        poster={'/images/idc-tiber-video-02-stilt.jpg'}
      >
        <source src={'../images/idc-tiber-backvideo-02-high.mp4'} type="video/mp4" media="(min-width: 1400px)" />
        <source src={'../images/idc-tiber-backvideo-02-low.mp4'} type="video/mp4" media="(max-width: 1399px)" />
      </video>
      <div className="hero-default-background"></div>
      <div className="internal-container title-container py-s9 px-s5 py-sm-s10 px-sm-s7 gap-s8">
        <div className=" title-headings-container gap-xs-s4 gap-sm-s6">
          <h1>
            <span className="h2 d-none d-sm-block text-white">Intel® Tiber™ AI Cloud</span>
            <span className="h3 d-block d-sm-none text-white">Intel® Tiber™ AI Cloud</span>
          </h1>
          <h2 className="text-white">
            <span className="display-2">
              Validate Your AI Vision, <br className="d-block d-sm-none" /> Faster
            </span>
          </h2>
          <span className="display-6 text-white d-none d-sm-block">
            Leverage our optimized infrastructure and developer solutions <br className="d-block d-sm-none" /> to
            improve your AI workloads.
          </span>
        </div>
        <ButtonGroup className="title-cta gap-s8 p-s4">
          <NavLink
            className="btn btn-secondary btn-lg"
            href={siteURL}
            role="button"
            intc-id="btn-get-started"
            data-wap_ref="btn-get-started"
            aria-label="Go to Get started"
            rel="noreferrer"
          >
            Get started
          </NavLink>
          <NavLink
            className="btn btn-outline-secondary btn-lg"
            href={contactSupport}
            role="button"
            intc-id="btn-contact-sale"
            data-wap_ref="btn-contact-sale"
            aria-label="Go to Contact"
            rel="noreferrer"
            target="_blank"
          >
            Contact
          </NavLink>
        </ButtonGroup>
      </div>
    </div>
  )
}

export default TitlePage
